//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { Opportunity } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeOpportunities = (
  opportunities: Serialized<Opportunity[]>,
): Opportunity[] => {
  const deserializedOpportunities = opportunities.map((opportunity) => ({
    ...opportunity,
    expiryDate: opportunity.expiryDate
      ? new Date(opportunity.expiryDate)
      : undefined,
  }));

  return deserializedOpportunities;
};
